module.exports = __webpack_public_path__ + "img/Fukka-FukaSeat_FrenchBeige.64434202.png";